// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"8eb8a84b","197":"da64d8ea","402":"edda8af3","419":"97996040","725":"902a1c79","759":"bb9f22d7"}[chunkId] + ".chunk.js";
};